import { Button } from '@components/button';
import { createForm, useCreateFormStore } from '@components/form';
import { Text } from '@components/text';
import { useScopedTranslate } from '@locale/translate';

import { useCurrentUser } from 'api/authentication/hooks';
import { useEditCompanyDetails } from 'api/company/hooks';

import { PreboardingPage } from './common';

import { CompanyPreboardingStepper, useNextStep } from '../navigation';

type FormData = { name: string };

const Form = createForm<FormData>();

export const CompanyNamePage = () => {
  const { t } = useScopedTranslate(locale);
  const formStore = useCreateFormStore();
  const editMutation = useEditCompanyDetails({ shouldNotShowSuccess: true });
  const formValues = formStore.useFormValues();
  const currentUser = useCurrentUser();
  const currentCompanyName = currentUser?.company.name;
  const navigateToNextStep = useNextStep();

  const handleContinue = async () => {
    await editMutation.mutateAsync(formValues);
    navigateToNextStep();
  };

  return (
    <PreboardingPage>
      <Text text={t('title')} font="heading1" center />
      <Form onSubmit={handleContinue} store={formStore}>
        <Form.TextField
          id="name"
          label={t('companyName')}
          validators={['required']}
          hideRequiredIndicator
          defaultValue={currentCompanyName !== currentUser?.email ? currentCompanyName : ''}
          maxLength={255}
        />
      </Form>
      <Button variant="primary-blue" onClick={() => handleContinue()} isDisabled={!formValues.name}>
        {t('core.continue')}
      </Button>
      <CompanyPreboardingStepper />
    </PreboardingPage>
  );
};

const locale = {
  en: {
    title: 'Setup a new company account',
    companyName: 'Company name',
  },
};
